export default __webpack_public_path__ + "static/media/gallery-wip-head-pins_00.cf4e904e.jpg";